import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";

import Localization from "../../localization";
import Button from "../../components/button";
import IconClose from "../../components/icons/close";
import IconSpinner from "../../components/icons/spinner";
import IconLogo from "../../components/icons/logo";
import { fixExternalLinks } from "../../utils/helper";
import { loadActiveOpenCalls } from "../../redux/actions/openCalls";

class OpenCallsDetails extends Component {
    componentDidMount() {
        this.props.loadActiveOpenCalls();
    }

    render() {
        const { openCallsData, locale, history, match } = this.props;

        let openCall = null;
        let title = null;
        let subTitle = null;
        let description = null;
        let button = null;

        if (match.params.type === "claim") {
            title = Localization[locale].info.claim;
            openCall = openCallsData.find(
                (item) => item.type === "reclamar_tempo"
            );
        } else if (match.params.type === "technic") {
            title = Localization[locale].info.technic;
            openCall = openCallsData.find((item) => item.type === "technical");
        } else {
            title = Localization[locale].info.artistic;
            openCall = openCallsData.find((item) => item.type === "artistic");
        }

        const className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 z-20";

        if (!openCall)
            return (
                <div className={className}>
                    <Helmet>
                        <body className="modal-open" />
                    </Helmet>
                    <div className="bg-blue flex flex-col items-center justify-center w-full">
                        <IconSpinner className="animate-spin w-25 xl:w-32 h-25 xl:h-32 text-pink" />
                        <IconLogo
                            className={
                                "w-140 xl:w-208 h-30 xl:h-46 mt-40 text-pink"
                            }
                        />
                    </div>
                </div>
            );

        if (match.params.category === "rules") {
            subTitle = Localization[locale].account.button_rules;
            description = openCall.rules;
            if (openCall.rules_pdf) {
                button = openCall.rules_pdf;
            }
        } else if (match.params.category === "judges") {
            subTitle = Localization[locale].account.button_jury;
            description = openCall.judges;
        } else if (match.params.category === "external") {
            subTitle = Localization[locale].account.button_external;
            description = openCall.external;
        } else if (match.params.category === "mentors") {
            subTitle = Localization[locale].account.button_mentors;
            description = openCall.mentors;
        } else if (match.params.category === "results") {
            subTitle = Localization[locale].open_calls.button_results;
            description = openCall.results;
        }

        return (
            <div className={className}>
                <Helmet>
                    <body className="modal-open" />
                </Helmet>
                <div
                    id="containerId"
                    className="bg-grey overflow-y-auto w-full"
                >
                    <div
                        name="elementName"
                        className="pt-30 xl:pt-40 pb-80 px-16 xl:px-50"
                    >
                        <div className="hidden xl:flex justify-end">
                            <Button
                                icon={
                                    <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                }
                                onClick={() => {
                                    history.goBack();
                                }}
                                style={"w-70"}
                            />
                        </div>
                        <div className="flex relative xl:mt-40">
                            <div className="xl:w-2/12" />
                            <div className="xl:w-10/12">
                                <p className="font-judge font-bold text-blue text-30 uppercase">
                                    {title}
                                </p>
                                <h1 className="font-bold xl:w-9/12 mt-40 text-30 xl:text-60 text-blue">
                                    {subTitle}
                                </h1>
                                <div className="xl:hidden absolute right-0 top-0">
                                    <Button
                                        icon={
                                            <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                        }
                                        onClick={() => {
                                            history.goBack();
                                        }}
                                        style={"w-50"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="article-body">
                            <div className="flex mt-30 xl:mt-60">
                                <div className="xl:w-2/12" />
                                <div className="xl:w-10/12">
                                    {description && (
                                        <div
                                            className="article-body xl:w-9/12 leading-tight article-break-word text-17 xl:text-23 text-blue"
                                            dangerouslySetInnerHTML={{
                                                __html: fixExternalLinks(
                                                    description
                                                ),
                                            }}
                                        />
                                    )}
                                    {button && (
                                        <div className="w-200  mt-30 xl:mt-60">
                                            <Button
                                                text={"PDF"}
                                                textStyle={
                                                    "font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                                }
                                                style={"mb-8 xl:m-8"}
                                                wrapperStyle="px-20"
                                                backgroundColor={"bg-grey"}
                                                url={button}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    openCallsData: state.openCalls.data,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadActiveOpenCalls,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OpenCallsDetails);
